﻿import { DebateContactPerson } from '../shared/debate-contact-person';
import { DebateResponsiblePerson } from '../shared/debate-responsible-person';
import { OfflineDebateFile } from './offline-debate-file';
import { OfflineDebateSession } from './offline-debate-session';

export class OfflineDebateDetail {
    id: number;
    debateStatus: string;
    debateCategory: string;
    debateKind: string;
    startDate: Date;
    endDate: Date;
    active: boolean;
    debateTitle: string;
    description: string;
    debateResponsiblePersons: Array<DebateResponsiblePerson>;
    debateContactPersons: Array<DebateContactPerson>;    
    files: Array<OfflineDebateFile>;
    sessions: Array<OfflineDebateSession>;
}